import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable()
export abstract class ApiService {
    public static openApiUrl = environment.apiBaseUrl + '/open-api/';
    public static privateApiUrl = environment.apiBaseUrl + '/cloud-api/';

    constructor(protected _http: HttpClient) {}
}
